export default __webpack_public_path__ + "static/media/Image3_Desktop.668e2d4f.png";